<template>
  <v-dialog
      v-model="showDialog"
      max-width="600"
  >
    <v-card>
      <div id="raster-time-plot" style="max-width: 600px; height: 400px"></div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            text
            @click="closeDialog"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex"
import Plotly from "plotly.js"

export default {
  name: "PlotTimeDialog",
  methods: {
    closeDialog() {
      this.SET_PLOT_DIALOG(false)
    },
    createPlot() {
      let data = [{
        x: this.getPlotData.x,
        y: this.getPlotData.y,
        mode: 'lines+markers'
      }];
      let config = {responsive: true}
      Plotly.newPlot('raster-time-plot', data, this.getPlotLayout, config);
    },
    ...mapMutations("app",["SET_PLOT_DIALOG"])
  },
  data: () => ({
    layout: ''
  }),
  computed: {
    ...mapState("app", ["showPlotDialog"]),
    ...mapGetters("app",["getPlotData","getPlotLayout"]),
    showDialog: {
      get() {
        return this.showPlotDialog
      },
      set(value) {
        this.SET_PLOT_DIALOG(value)
      },
    },
  },
  updated() {
    this.createPlot()
  }
}
</script>

<style scoped>
</style>

<style>
</style>